<div class="modal-header">
  @if (arbetsorder) {
    <h2 class="modal-title fkm-modal-title" id="modal-title">
      Hantera rader - {{ arbetsorder.beteckning }} {{ arbetsorder.namn }}
    </h2>
  }
</div>

@if (arbetsorder) {
  <rask-container-block>
    <rask-input label="Rader arbetsorder" [readonly]="true" [(ngModel)]="antalRader"></rask-input>
    <rask-input label="Rader att skicka med VO" [readonly]="true" [(ngModel)]="aktivaRader"></rask-input>
    <rask-input label="Virkesorder" [readonly]="true" [(ngModel)]="voStatus"></rask-input>
    @if (skickadeRader > 0) {
      <rask-input label="Rader på senast skickad VO" [readonly]="true" [(ngModel)]="skickadeRader"></rask-input>
    }
    @if (aktivaRader > 50 && !hasBeenSent) {
      <rask-validation-message-row type="warning"
        message="Antalet rader för att skicka virkesorder behöver begränsas till 50 eller mindre för att kunna skicka virkesorder.">
      </rask-validation-message-row>
    }
    @if (aktivaRader > 60 && hasBeenSent) {
      <rask-validation-message-row type="warning"
        message="Antalet rader för att skicka virkesorder behöver begränsas till 60 eller mindre för att kunna skicka virkesorder.">
      </rask-validation-message-row>
    }
    <div class="row">
      <rask-button
        class="generate-button float-start"
        color="secondary"
        (click)="generateSuggestion()">
        Föreslå begränsning
      </rask-button>
    </div>
    <div class="listContainer">
      @if (listData) {
        <rask-list [data]="listData" [fixedHeader]="true" [innerHeader]="true">
          <rask-list-column header="Destineringsalternativ" field="destineringsalternativ"></rask-list-column>
          <rask-list-column header="Transportavstånd" field="transportavstand"></rask-list-column>
          <rask-list-column header="Destinering" field="destinering"></rask-list-column>
          <rask-list-column header="Skickas med Vo" field="skickasMedVo">
            <ng-template let-row="row">
              <rask-checkbox
                class="row-checkbox"
                (click)="checkChanged(row)"
                [(ngModel)]="row.skickasMedVo"
                [disabled]="row.isLocked"
                [attr.disabled]="row.isLocked ? true : null">
              </rask-checkbox>
              @if (row.nrOfRows > 1) {
                <span class="nrOfRows">({{row.nrOfRows}} rader)</span>
              }
            </ng-template>
          </rask-list-column>
        </rask-list>
      }
    </div>
  </rask-container-block>
}

<ng-container footer>

  <rask-button class="footer-button"
    color="secondary"
    (click)="tryClose()">
    Avbryt
  </rask-button>

  <rask-button class="footer-button"
    color="primary"
    (click)="save()"
    [disabled]="!isDirty">
    Spara
  </rask-button>

</ng-container>
